export const SIGNED_OUT_QUERY_PARAM = 'signed_out=true';
export const AMPLIFY_NO_CURRENT_USER_ERROR = 'No current user';
export const SUCCESSFUL_SIGN_IN_REDIRECT_KEY = 'successfulSignInRedirectUrl';

export const ROUTES = {
  REGISTER: '/u/register',
  SIGN_IN: '/u/sign-in',
  SOCIAL_AUTH_REDIRECT: '/u/social-auth-redirect',
  MARKETING_PREFERENCES: '/u/marketing-preferences',
  SIGN_OUT: '/u/sign-out',
  FORGOT_PASSWORD: '/u/password/new?original_url=%2Fu%2Fsign-in',
  RESET_PASSWORD_REQUIRED: '/u/password/new?resetPassword=1',
};

export const COOKIES = {
  LOGGED_IN: 'USER_LOGGED_IN',
  COGNITO_ID: 'cognitoId',
  COGNITO_JWT: 'authToken',
  XSRF_TOKEN: 'XSRF-TOKEN',
  REMEMBER_TOKEN: 'remember_token',
  FAVOURITES_LIST_ID: 'favourites_list_id',
  ANONYMOUS_BASKET_COOKIE: 'anon_basket_id',
  AWS_CREDENTIALS: 'aws_credentials',
  NEW_BASKET_ENABLED: 'enable_authenticated_header',
};
